/**
  * @class meleDopplerItem
  * @description
  *
  * # Purpose
  * Implements `<mele-doppleritem>` as a clickable button for Doppler radar event
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  result: { description: 'resolution of measurement', type: 'string' },
  speed: { description: 'speed of vehicle', type: 'integer' },
  direction: { description: 'direction of vehicle', type: 'string', enum: ['approaching', 'receding'] },
  lane: { description: 'lane of vehicle', type: 'integer' },
  distance: { description: 'distance of vehicle', type: 'integer' },
  selected: { description: 'indicates the button is selected', type: 'boolean' },
}, meleElement._properties)

const SVG_ARROWS = require('../../res/icons/lanes.js')

export default class meleDopplerItem extends meleElement {
  init() {
    super.init()
    this.innerHTML = `
    <left>
      <svg viewBox="0 0 10 10">
        <path class="lanes" d="${SVG_ARROWS[123]}" fill="none" stroke="#ffffffaa" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="5,5"/>
        <path class="lanedir" d="" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div class="speed">-</div>
    </left>
    <middle>
        <div class="datetime">-</div>
        <div class="distance">-</div>
        <div class="result">-</div>
      </table>
    </middle>
    <right>
      <img />
    </right>
  `
  } // init

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "key"; same effect as changed language; will refresh list of items
  */
  keyChanged(value) {
    const ms = Math.floor(value/1000)
    if(ms>0) {
      const d = new Date(ms)
      this.querySelector('.datetime').innerHTML = (
        String(d.getFullYear()).padStart(4, '0') + '-' +
      String(d.getMonth()+1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0') + '<br/>' +
      String(d.getHours()).padStart(2, '0')+':'+
      String(d.getMinutes()).padStart(2, '0')+':'+
      String(d.getSeconds()).padStart(2, '0')+'.'+
      String(ms%1000).padStart(3, '0')
      )
    }else {
      this.querySelector('.datetime').innerHTML = '-'
    }
  } // keyChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "reason"
  */
  resultChanged(value) {
    this.querySelector('.result').innerHTML = String(value??'')
  } // resultChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "speed"
  */
  speedChanged(value) {
    const speed = Math.floor(value)
    this.querySelector('.speed').innerHTML = speed>0 ? speed : '-'
  } // speedChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "direction"
  */
  directionChanged(dir) {
    let lane = parseInt(this.lane)
    lane = lane>3 ? 3 : lane>0 ? lane : 0
    const arrows = SVG_ARROWS[dir+lane] || ''
    this.querySelector('path.lanedir').setAttribute('d', arrows)
  } // directionChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "lane"
  */
  laneChanged(lane) {
    const dir = this.direction
    lane = parseInt(this.lane)
    lane = lane>3 ? 3 : lane>0 ? lane : 0
    const arrows = SVG_ARROWS[dir+lane] || ''
    this.querySelector('path.lanedir').setAttribute('d', arrows)
  } // laneChanged

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "distance"
  */
  distanceChanged(dist) {
    dist = parseFloat(dist)
    this.querySelector('.distance').innerHTML = dist>0 ? dist.toFixed(1)+' m' : ''
  } // distanceChanged
} // class meleDopplerItem

meleDopplerItem._properties = PROPERTIES
meleDopplerItem.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-doppleritem', meleDopplerItem)
